<template>
  <a-card :bordered="false">
    <!-- 操作按钮区域 -->
    <div class="table-operator" :md="24" :sm="24" style="margin: 0 0px 10px 2px">
      <a-button :readOnly="currentDept.orgCategory != 3" @click="handleAddPaper" type="primary" icon="plus"
        >关联试卷</a-button
      >

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"> <a-icon type="delete" />删除 </a-menu-item>
          <a-menu-item v-if="currentDept.orgType == '1' || currentDept.orgType == '2'" key="2" @click="handleShowClone(false)">
            <a-icon type="apartment" />分配
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600"> {{ selectedRowKeys.length }} </a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="showReport(record.id)">报告</a>
          <a-divider type="vertical" />
          <a @click="handleEditPaperSchedule(record)">安排考试</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-if="currentDept.orgType == '1' || currentDept.orgType == '2'">
                <a @click="handleShowClone(record.id)">分配</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定要将本试卷从班级移除吗?" @confirm="() => handleDelete(record.id)">
                  <a>移除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handlePreGenUserPaper(record.id)">
                  <span slot="title">
                    <p>确定要预生成答题卡吗?</p>
                    <p>修改试卷后需要重新预生成！</p>
                  </span>
                  <a>预生成答题卡</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          
        </span>
        <span slot="status" slot-scope="t,r" @click="handleEditPaperSchedule(r)">
            <a-tag color="gray" v-if="t==0">不开放</a-tag>
            <a-tag color="green" v-if="t==1">直接开放</a-tag>
            <a-tooltip v-if="t==2">
              <template slot="title">
                <p>开始：{{r.startTime}}</p>
                <p>结束：{{r.endTime}}</p>
              </template>
              <a-tag color="blue">定时开放</a-tag>
            </a-tooltip>
            <a-tooltip v-if="t==3">
              <template slot="title">
                <p>排期ID：{{r.unlockPaperDeptId}}</p>
                <p>分数：{{r.unlockScore}}</p>
              </template>
              <a-tag color="blue">完成考试开放</a-tag>
            </a-tooltip>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <TeachingPaperDeptModal ref="editPaperSchedule" @ok="modalFormOk" />
    <T-Select-Paper-Modal ref="selectPaperModal" @ok="handleOk" />
    <j-modal title="考场报告" :visible="reportVisible" width="900" :switchFullscreen="true" :destroyOnClose="true" :footer="null"
      @cancel="reportVisible = false">
      <DeptPaperReport ref="deptPaperReport"/>
    </j-modal>
    
    <a-modal :visible="showCloneModal" title="分配试卷" @ok="batchClone" @cancel="showCloneModal=false">
      <p>将试卷分配至下级部门，开考方式和开考时间将继承设置</p>
      <br />
    </a-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, postAction, deleteAction } from '@/api/manage'
import TSelectPaperModal from '@/theme/wuge/views/mockTest/components/testPaper/selector/TSelectPaperModal'
import TeachingPaperDeptModal from './TeachingPaperDeptModal'
import DeptPaperReport from './DeptPaperReport'
export default {
  name: 'DeptPaperInfo',
  mixins: [JeecgListMixin],
  components: {
    TSelectPaperModal,
    TeachingPaperDeptModal,
    DeptPaperReport
  },
  data() {
    return {
      showCloneModal: false,
      reportVisible: false, //考场报告
      copyCourseIds: '',
      description: '试卷信息',
      currentDeptId: '',
      currentDept: {},
      // 表头
      columns: [
        {
          title: '排期ID',
          align: 'center',
          dataIndex: 'id',
        },
        {
          title: '考试名',
          align: 'center',
          dataIndex: 'examName',
        },
        {
          title: '试卷名',
          align: 'center',
          dataIndex: 'paperName',
        },
        {
          title: '试卷库',
          align: 'center',
          dataIndex: 'paperType_dictText',
        },
        {
          title: '试卷类型',
          align: 'center',
          dataIndex: 'isSimulation',
          customRender(v){
            switch(v){
              case 0: return '正式卷'
              case 1: return '模拟卷'
              case 2: return '作业卷'
              case 3: return '练习卷'
              default: return v
            }
          }
        },
        // {
        //   title: '难度',
        //   align: 'center',
        //   dataIndex: 'paperDifficulty_dictText',
        // },
        {
          title: '限时',
          align: 'center',
          dataIndex: 'timeLimit',
        },
        {
          title: '总分',
          align: 'center',
          dataIndex: 'totalScore',
        },
        // {
        //   title: '试卷状态',
        //   align: 'center',
        //   dataIndex: 'paperStatus_dictText',
        // },
          {
            title:'开放状态',
            align:"center",
            dataIndex: 'openMethod',
            scopedSlots:{customRender: 'status'}
          },
          // {
          //   title: '关联课程',
          //   align: 'center',
          //   dataIndex: 'courseId_dictText',
          // },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            align: 'center',
            width: 180,
          },
      ],
      isorter: {
        column: 'teachingPaperDept.createTime',
        order: 'desc',
      },
      url: {
        list: '/teaching/teachingPaperDept/list',
        add: '/teaching/teachingPaperDept/add',
        addOrUpdate: '/teaching/teachingPaperDept/addOrUpdate',
        edit: '/teaching/teachingPaperDept/edit',
        delete: '/teaching/teachingPaperDept/delete',
        deleteBatch: '/teaching/teachingPaperDept/deleteBatch',
        cloneBatch: '/teaching/teachingPaperDept/cloneBatch',
      },
    }
  },
  created() {},

  methods: {
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      if (this.currentDeptId === '') return
      var params = this.getQueryParams() //查询条件
      params.deptId = this.currentDeptId
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        }
      })
    },
    showReport(id){
      this.reportVisible = true
      this.$nextTick(() => {
        this.$refs.deptPaperReport.open(id)
      })
    },
    handleShowClone(id) {
      this.showCloneModal = true
      if (id) {
        this.selectedRowKeys = [id]
      }
    },
    batchClone() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        var that = this
        console.log(this.currentDeptId)
        getAction(that.url.cloneBatch, { ids: ids, departId: this.currentDeptId}).then((res) => {
          if (res.success) {
            that.$message.success(res.message)
            that.loadData()
            that.onClearSelected()
          } else {
            that.$message.warning(res.message)
          }
          that.showCloneModal = false
        })
      }
    },
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!')
        return
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        var that = this
        console.log(this.currentDeptId)
        this.$confirm({
          title: '确认删除',
          content: '是否从班级中删除选中试卷?',
          onOk: function () {
            deleteAction(that.url.deleteBatch, { ids: ids }).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.loadData()
                that.onClearSelected()
              } else {
                that.$message.warning(res.message)
              }
            })
          },
        })
      }
    },
    handleDelete: function (id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!')
        return
      }
      var that = this
      deleteAction(that.url.delete, { id: id }).then((res) => {
        if (res.success) {
          that.$message.success(res.message)
          if (this.selectedRowKeys.length > 0) {
            for (let i = 0; i < this.selectedRowKeys.length; i++) {
              if (this.selectedRowKeys[i] == id) {
                this.selectedRowKeys.splice(i, 1)
                break
              }
            }
          }
          that.loadData()
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    handlePreGenUserPaper(paperDeptId){
      getAction("/teaching/teachingPaperDept/preGenUserPaper", {paperDeptId: paperDeptId}).then(res=>{
        this.$message.info(res.message)
      })
    },
    open(record) {
      console.log(record)
      this.currentDept = record
      this.currentDeptId = record.id
      this.loadData(1)
    },
    clearList() {
      this.currentDeptId = ''
      this.dataSource = []
    },
    hasSelectDept() {
      if (this.currentDeptId == null) {
        this.$message.error('请选择一个部门!')
        return false
      }
      return true
    },
    //添加课程
    handleAddPaper() {
      if (this.currentDeptId == '') {
        this.$message.error('请选择一个部门!')
      } else {
        this.$refs.selectPaperModal.visible = true
      }
    },
    //排课
    handleEditPaperSchedule(record) {
      this.$refs.editPaperSchedule.edit(record)
      this.$refs.editPaperSchedule.disableSubmit = false
    },
    handleOk(rows, keys) {
      let params = {}
      params.deptId = this.currentDeptId
      params.resIdList = []
      for (var a = 0; a < rows.length; a++) {
        params.resIdList.push(rows[a].id)
      }
      console.log(params)
      postAction(this.url.addOrUpdate, params).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
  },
}
</script>
<style scoped>
/** Button按钮间距 */
.ant-btn {
  margin-left: 3px;
}

.ant-card {
  margin-left: -30px;
  margin-right: -30px;
}

.table-page-search-wrapper {
  margin-top: -16px;
  margin-bottom: 16px;
}
</style>